(function () {
  angular.module('MktzapApp.Factories')
    .factory('CampaignManagementService', CampaignManagementService);

  CampaignManagementService.$inject = ['$resource'];
  function CampaignManagementService ($resource) {
    return $resource('', {}, {
      save: { url: frontUrl + '/campaign-management/save', method: 'POST', isArray: false },
      index: { url: frontUrl + '/campaign-management/index', method: 'GET', isArray: false },
      downloadFile: { url: frontUrl + '/campaign-management/download-file/:id', method: 'GET', isArray: false }
    });
  }
})();
